export default __webpack_public_path__ + "static/media/next-white.6faf3f6b.svg";